import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const ja: Translations = {
  common: {
    appName: appName,
    loading: '読み込み中...',
    save: '保存',
    cancel: 'キャンセル',
    confirm: '確認',
    delete: '削除',
    edit: '編集',
    back: '戻る',
    search: '検索',
    noResults: '結果が見つかりません',
    error: 'エラーが発生しました',
    success: '成功',
  },
  header: {
    searchPlaceholder: 'ニュース、トピック、ハッシュタグを検索...',
    searchPlaceholderMobile: '検索...',
    home: 'ホーム',
    hotgirl: 'ホットガール',
    coser: 'コスプレイヤー',
    model: 'モデル',
    upload: 'アップロード',
    notifications: '通知',
    login: 'ログイン',
    register: '登録',
  },
  footer: {
    tagline: `のコスプレイヤー、ホットガール、モデル写真の最高の共有プラットフォーム。${appName}の`,
    copyright: `© {year} ${appName}. All rights reserved.`,
    sections: { explore: '探索', account: 'アカウント', support: 'サポート' },
    links: {
      home: 'ホーム', hotgirl: 'ホットガール', coser: 'コスプレイヤー', model: 'モデル', aoDai: 'アオザイ',
      login: 'ログイン', register: '登録', upload: '写真をアップロード', dashboard: 'ダッシュボード',
      terms: '利用規約', privacy: 'プライバシーポリシー', report: '違反を報告', contact: 'お問い合わせ',
    },
  },
  collections: {
    title: 'コレクション',
    createAlbum: 'アルバムを作成',
    saved: '保存済み',
    noSaved: 'まだ保存した写真がありません',
    noSavedHint: '写真を探す →',
    removedSave: '保存を解除しました',
    createModalTitle: '新しいアルバムを作成',
    albumNamePlaceholder: 'アルバム名...',
    cancel: 'キャンセル',
    create: '作成',
    albumCreated: 'アルバムを作成しました',
  },
  home: {
    title: '発見する',
    titleHighlight: '美しさ',
    titleSuffix: '人生の',
    subtitle: 'コスプレイヤー、ホットガール、モデルの写真が毎日更新されます',
    sortNewest: '最新',
    sortTrending: 'トレンド',
    sortPopular: '人気',
    allCategories: 'すべて',
    noMorePosts: 'すべての写真を見ました',
  },
  auth: {
    login: {
      title: 'ログインして続ける',
      continueWithGoogle: 'Google で続ける',
      orLoginWithEmail: 'またはメールでログイン',
      email: 'メール',
      password: 'パスワード',
      forgotPassword: 'パスワードを忘れた？',
      submitButton: 'ログイン',
      loading: 'ログイン中...',
      noAccount: 'アカウントをお持ちでないですか？',
      registerLink: '今すぐ登録',
      errorCredentials: 'メールまたはパスワードが正しくありません',
      successLogin: 'ログインしました！',
    },
    register: {
      title: '無料アカウントを作成',
      displayName: '表示名',
      displayNamePlaceholder: '山田太郎',
      email: 'メール',
      password: 'パスワード',
      passwordPlaceholder: '8文字以上',
      confirmPassword: 'パスワードを確認',
      submitButton: '登録',
      loading: 'アカウント作成中...',
      hasAccount: 'すでにアカウントをお持ちですか？',
      loginLink: 'ログイン',
      errorPasswordMismatch: 'パスワードが一致しません',
      errorPasswordLength: 'パスワードは8文字以上必要です',
      errorGeneric: '登録に失敗しました',
      successRegister: '登録が完了しました！',
      emailTaken: 'メールはすでに使用されています',
      serverError: 'サーバーエラーが発生しました。後で再試行してください。',
    },
    forgotPassword: {
      title: 'パスワードを忘れた',
      subtitle: 'メールを入力してリセットリンクを送信します',
      email: 'メール',
      submitButton: 'リセットリンクを送信',
      backToLogin: 'ログインに戻る',
      sending: '送信中...',
      emailSent: 'メールが送信されました！',
      checkEmail: '{email} の受信トレイを確認してパスワードリセットリンクを受け取ってください。',
      instructions: 'メールアドレスを入力すると、パスワードリセットリンクが送信されます。',
    },
  },
  userMenu: {
    dashboard: 'ダッシュボード',
    collections: 'コレクション',
    settings: '設定',
    logout: 'ログアウト',
  },
  settings: {
    title: 'アカウント設定',
    profile: {
      nav: 'プロフィール',
      title: 'プロフィール情報',
      displayName: '表示名',
      username: 'ユーザー名',
      website: 'ウェブサイト',
      bio: '自己紹介',
      bioPlaceholder: '自己紹介を書いてください...',
      changeAvatar: 'アバターを変更',
      avatarHint: 'JPG、PNG、WebP 最大5MB',
      saveButton: '変更を保存',
      saving: '保存中...',
      savedSuccess: '変更が保存されました',
    },
    password: { 
      nav: 'パスワード',
      title: 'パスワードを変更',
      fields: {
        currentPassword: '現在のパスワード',
        newPassword: '新しいパスワード',
        confirm: '新しいパスワードを確認',
      },
      errors: {
        confirm: '新しいパスワードが一致しません',
        minLength: 'パスワードは8文字以上必要です',
      },
      success: 'パスワードが変更されました',
      saving: '保存中...',
      submit: 'パスワードを変更',
    },
    notifications: { 
      nav: '通知',
      title: '通知設定',
      options: {
        likes: 'あなたの写真が好きな人がいるとき',
        comments: '誰かがコメントするとき',
        replies: '誰かがあなたのコメントに返信するとき',
        follows: '誰かがあなたをフォローするとき',
        approved: '投稿が承認されたとき',
        email_digest: '毎週のメールダイジェスト',
        marketing: 'プロモーションやイベントの通知',
      },
      saveSuccess: '通知設定が保存されました',
      saving: '保存中...',
      saveButton: '設定を保存',
    },
    security: { 
      nav: 'セキュリティ',
      twoFactorAuth: '2段階認証 (2FA)',
      twoFactorAuthHint: 'アプリの認証コードを使用してセキュリティを強化します',
      comingSoon: '近日公開',
      activeSessions: 'アクティブセッション',
      currentBrowser: '現在のブラウザ',
      lastLogin: '前回のログイン',
      active: 'アクティブ',
      dangerZone: '危険ゾーン',
      deleteAccountHint: 'アカウントを削除すると、すべてのデータが永久に削除されます。',
      deleteAccount: 'アカウントを削除',
    },
  },
  post: {
    likes: '{count} いいね',
    views: '{count} 回表示',
    shares: '{count} 回シェア',
    comments: '{count} コメント',
    save: '保存',
    saved: '保存済み',
    share: 'シェア',
    linkCopied: 'リンクをコピーしました！',
    follow: 'フォロー',
    following: 'フォロー中',
    relatedPosts: '関連投稿',
    commentPlaceholder: 'コメントを書く...',
    commentLoginPlaceholder: 'コメントするにはログインしてください...',
    commentSubmit: '投稿',
    commentSubmitting: '投稿中...',
    noComments: 'まだコメントがありません。最初のコメントをどうぞ！',
    savedToCollection: 'コレクションに保存しました',
    removedFromCollection: '保存を解除しました',
    description: '説明',
    profileView: 'プロフィールを見る',
    replies: '返信',
    unsaved: '保存を解除しました',
    liked: 'いいね済み',
    like: 'いいね',
  },
  notifications: {
    title: '通知',
    empty: '通知はありません',
    markAllRead: 'すべて既読にする',
    types: {
      like_post: 'あなたの写真をいいねしました',
      comment: 'あなたの写真にコメントしました',
      reply: 'あなたのコメントに返信しました',
      follow: 'あなたをフォローしました',
      approve: 'あなたの投稿が承認されました',
      reject: 'あなたの投稿が拒否されました',
      system: 'システム通知',
    },
  },
  search: {
    title: '検索結果：',
    result: '結果',
    tryOtherKeywords: '他のキーワードを試してみてください。',
    noResults: '検索結果がありません：',
    placeholder: '検索...',
    thisHashtag: 'このハッシュタグを含む写真',
    results: '件の結果',
  },
  upload: {
    title: '写真をアップロード',
    dragDrop: 'ドラッグ＆ドロップまたはクリックして選択',
    supportedFormats: 'JPG、PNG、WebP、GIF に対応',
    submit: '公開',
    submitting: '公開中...',
    titleField: 'タイトル',
    cover: 'カバー',
    titlePlaceholder: '魅力的なタイトルを入力してください...',
    descriptionField: '説明',
    descriptionPlaceholder: '写真セットの詳細な説明を入力してください...',
    hashtagsField: 'ハッシュタグ',
    statusField: 'ステータス',
    statusPublic: '公開',
    statusPrivate: '非公開',
    statusDraft: '下書き',
    error: 'アップロード中にエラーが発生しました',
    errorSelect: '少なくとも1枚の写真を選択してください',
    errorTitle: 'タイトルを入力してください',
    photos: '写真',
    uploading: 'アップロード中...',
  },
  notFound: {
    title: 'ページが見つかりません',
    subtitle: 'お探しのページは存在しません。',
    backHome: 'ホームに戻る',
  },
  liked: {
    title: 'いいねした投稿',
    empty: 'まだいいねした投稿はありません',
  },
  user: {
    unknown: '匿名',
  },
  globalError: {
    title: 'エラーが発生しました',
    subtitle: 'ご不便をおかけして申し訳ありません。もう一度お試しください。',
    retry: '再試行',
  },
  username: {
    posts: '投稿',
    likes: 'いいね',
    followers: 'フォロワー',
    following: 'フォロー中',
    editProfile: 'プロフィールを編集',
    message: 'メッセージ',
    noPosts: 'まだ投稿がありません',
    bio: 'の写真を見る',
    notFound: 'ユーザーが見つかりません',
  },
  topic: {
    notFound: 'テーマが見つかりません',
    viewTitle: 'テーマの写真を見る ',
  },
  dashboard: {
    title: 'ダッシュボード',
    welcome: 'ようこそ',
    stats: {
      posts: '投稿',
      views: '表示',
      likes: 'いいね',
      comments: 'コメント',
    },
  },
  adsblock: {
    title: "AdBlockをご利用中です",
    description: "高画質の画像を表示し、サイトを無料で維持するためにAdBlockを無効にしてください。",
    action: "無効にしました — 再読み込み",
    cancel: "スキップ"
  },
  pwa: {
    title: ` ${appName}をインストールして、より良い体験を！`,
    iosSubtitle: `共有を押して → ホーム画面に追加`,
    androidSubtitle: `新しい写真セットがリリースされるとすぐに通知を受け取る`,
    installButton: `インストール`,
    disclaimer: `クイックインストール、アプリストアは不要です。`,
  },
  autotrans: {
    title: '自動翻訳',
    translated: '翻訳',
    origin: '元のコンテンツ',
  },
  subscription: {
    title: '通知を購読',
    description: '新しい写真セットがリリースされるとすぐに通知を受け取ります。',
    subscribeButton: '購読',
    unsubscribeButton: '購読を解除',
    subscribed: '通知を購読しています。',
    unsubscribed: '通知の購読を解除しました。',
    error: '購読の更新中にエラーが発生しました。もう一度お試しください。',
    success_tit: '🎉 通知が有効になりました！',
    denied_tit: '通知が拒否されました',
    error_tit: 'エラーが発生しました',
    success_des: '新しいコンテンツが利用可能になると通知を受け取ります。',
    denied_des: 'ブラウザの設定で再度有効にできます。',
    error_des: '後でもう一度お試しください。',
    skip: 'スキップ',
    processing: '処理中...',
    noti: '通知を有効にする',
    rule: '新しいコンテンツの通知のみを表示します。',
    notify_title: `通知 - ${appName}`,
    notify_body: "新しいギャラリーが公開されました。今すぐチェックしてください！",
  },
  contact: {
    title: 'お問い合わせ',
    subtitle: 'ご意見をお聞かせください！以下のフォームにご記入いただければ、できるだけ早くご連絡いたします。',
    name: '名前',
    email: 'メール',
    subject: '件名',
    message: 'メッセージ',
    submitButton: 'メッセージを送信',
    sending: '送信中...',
    successTitle: 'メッセージが送信されました！',
    successMessage: 'ご連絡いただきありがとうございます。すぐにご返信いたします。',
    errorTitle: 'エラーが発生しました',
    errorMessage: 'メッセージの送信中にエラーが発生しました。もう一度お試しください。',
    res_time_title: '応答時間',
    res_time: '通常、1〜3営業日以内にご返信いたします。',
    report_content: 'コンテンツを報告',
    report_content_hint: '投稿やユーザーを報告するには、コンテンツ上の報告ボタンを直接使用するか、上記の「コンテンツを報告」を選択してください。',
    value_default: 'トピックを選択',
    value_general: '一般的な問い合わせ',
    value_report: 'コンテンツを報告',
    value_account: 'アカウントの問題',
    value_business: 'ビジネス / パートナーシップ',
    value_feedback: 'フィードバックと提案',
    value_other: 'その他'
  },
  language: {
    label: `言語`,
    en: `English`, vi: `Tiếng Việt`, zh: `中文`, ja: `日本語`,
    ko: `한국어`, ar: `العربية`, fr: `Français`, es: `Español`,
    ru: `Русский`,
    hi: `हिन्दी`,
    id: `Indonesia`,
    de: `Deutsch`,
    pt: `Português`,
    it: `Italiano`,
  },
};

export default ja;
